import '../scss/pages/postuler.scss';


import 'jquery-validation/dist/additional-methods.min';

var locale = $("#postuler-form").attr('data-locale');
var tah_lang = false;
if (locale === 'tah') {
	tah_lang = true;
}
jQuery(function ($) {

	setTimeout(() => {
		$(".select-select2").select2();
		// Set default value null
		$(".select-select2").val(null).trigger("change");
		$(".select-select2").on("select2:select", function (e) {
			$(this).parent().addClass("select-filled");
		});
	}, 0);

	/**
	 *  Funtion helper: Upload file component
	 *
	 */
	function uploadFileComponent(
		uploadFileInputName,
		uploadFileSize,
		parentUploadFile
	) {
		$(uploadFileInputName).on("change", function () {
			const fileNameButton = $(
				`.${parentUploadFile} .form-upload-single-link__button`
			);
			const fileNameText = fileNameButton.find(".text");
			var fileUpload = this.files[0];
			var trad_file_size = "Pdf max 1 Mo, cette taille de fichier est";
			var trad_select_file = "Sélectionner un fichier";
			if (tah_lang) {
				trad_file_size = "Pdf fāito teiaha a’e e 1 Mo, teie fāito pu’e ‘api uira e mea";
				trad_select_file = "A mā’iti i te hō’ē pu’e ‘api uira";
			}
			// console.log(fileUpload);
			if (fileUpload) {
				let numberConvertSize = 1024;
				let fileNameUpload = fileUpload.name;
				let fileSizeUpload = (
					fileUpload.size /
					numberConvertSize /
					numberConvertSize
				).toFixed(2);
				// console.log("[fileUpload]:", fileUpload);
				if (fileSizeUpload > uploadFileSize) {
					alert(
						trad_file_size +
							fileSizeUpload +
							" MB"
					);
					fileNameButton.removeClass("uploaded");
					fileNameText.text(trad_select_file);
					this.value = null;
					// console.log("this value is :", this.value);
				} else {
					fileNameButton.addClass("uploaded");
					fileNameButton.attr("data-size-file", fileSizeUpload);
					fileNameText.text(fileNameUpload);
					// console.log("This file name is:", fileNameUpload);
					// console.log("This file size is: " + fileSizeUpload + " MB");
					// console.log("this value is :", this.value);
				}
			} else {
				fileNameButton.removeClass("uploaded");
				fileNameText.text(trad_select_file);
				// console.log("this value is :", this.value);
			}
		});
	}

	/**
	 * Method validate Email
	 *
	 */
	$.validator.addMethod("validateEmail", function (value, element) {
		return (
			this.optional(element) ||
			/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
				value
			)
		);
	});

	/**
	 * Function handle validate form
	 *
	 */
	$("#postuler-form input[name='job_apply[phone]']").inputmask("99 99 99 99", {
		showMaskOnHover: false,
		showMaskFocus: false,
	});
	var trad_required = "Ce champ est obligatoire";
	var trad_email = "Veuillez saisir une adresse e-mail valide.";
	var trad_file_format = "Le fichier doit être au format pdf,png,jpg";
	var trad_pdf = "Le fichier doit être au format pdf";
	if (tah_lang) {
		trad_required = "Mea fa’ahepohia ‘ia fa’a’ī i teie ārea";
		trad_email = "A patapata mai i te hō’ē nohora’a ‘īmere mana";
		trad_file_format = "E tītauhia te hō’ē pu’e ‘api uira pdf, png, jpg";
		trad_pdf = "E tītauhia i te hō’ē pu’e ‘api uira pdf";
	}
	$("#postuler-form").validate({
		debug: true,
		errorClass: "error",
		errorPlacement: function (error, element) {
			error.appendTo(
				element.closest(".form-group").next(".error-message")
			); // replace error to closest 'trinity-form-group'
		},
		ignore: [], // ignore all hidden, except element have class 'hidden-required'
		rules: {
			'job_apply[name]': {
				required: true,
			},
			'job_apply[firstname]': {
				required: true,
			},
			'job_apply[email]': {
				required: true,
				validateEmail: true,
			},
			'job_apply[applyType]': {
				required: true,
			},
			'job_apply[job]': {
				required: true,
			},
			'job_apply[degree]': {
				required: true,
			},
			'job_apply[experience]': {
				required: true,
			},
			'job_apply[domain]': {
				required: true,
			},
			'job_apply[subject]': {
				required: true,
			},
			'job_apply[message]': {
				required: true,
			},
			upload_cv: {
				required: true,
				extension: "pdf|png|jpg",
			},
			upload_motivation: {
				required: true,
				extension: "pdf|png|jpg",
			},
			upload_diplomes: {
				// required: true,
				extension: "pdf|png|jpg",
			},
			'recaptcha-is-valid':{
				required: true
			}
		},
		messages: {
			'job_apply[name]': trad_required,
			'job_apply[firstname]': trad_required,
			'job_apply[email]': {
				required: trad_required,
				email: trad_email,
				validateEmail: trad_email,
			},
			'job_apply[applyType]': trad_required,
			'job_apply[job]': trad_required,
			'job_apply[degree]': trad_required,
			'job_apply[experience]': trad_required,
			'job_apply[domain]': trad_required,
			'job_apply[subject]': trad_required,
			'job_apply[message]': trad_required,
			upload_cv: {
				required: trad_required,
				extension: trad_file_format,
			},
			upload_motivation: {
				required: trad_required,
				extension: trad_file_format,
			},
			upload_diplomes: {
			// 	required: trad_required,
				extension: trad_pdf,
			},
			'recaptcha-is-valid':{
				required: trad_required
			},
		},
		// submitHandler: function (form) {
		// 	console.log("submitHandler 1", form);
		// 	$(form).submit();
		// },
	});

	/**
	 * Call valid when submit form
	 *
	 */

	$("body").on("click", "#postuler-form .submit-form .btn", function () {
		const isValid = $("#postuler-form").valid();
		if (isValid) {
			$("#postuler-form")[0].submit();
		}
	});

	/**
	 * Call function Upload file component
	 *
	 */

	uploadFileComponent(".upload-cv #upload-cv", "1", "upload-cv");
	uploadFileComponent(
		".upload-motivation #upload-motivation",
		"1",
		"upload-motivation"
	);
	uploadFileComponent(
		".upload-diplomes #upload-diplomes",
		"5",
		"upload-diplomes"
	);
});

function setRecaptchaFormValue() {
	return new Promise(function(resolve, reject) {
		var trad_recaptcha_missing = "Recaptcha non défini";
		var trad_recaptcha_error = "Une erreur s\'est produite avec le Recaptcha: la réponse n\'a pas abouti.";
		if (tah_lang){
			trad_recaptcha_missing = "Recaptcha i ‘ore i fa’ata’ahia";
			trad_recaptcha_error = "‘Ua tupu te hō’ē hape ‘e te Recaptcha : aita te pāhonora’a i hope";
		}
		if (grecaptcha === undefined) {
			alert(trad_recaptcha_missing);
			reject();
		}

		var response = grecaptcha.getResponse();
		var recaptchaElement = $("#recaptcha-is-valid"),
			recaptchaError = $('#recaptcha-is-valid-error');
		recaptchaElement.val(response);
		if (recaptchaElement.val().length > 0) {
			recaptchaError.css({'display': 'none'})
		}

		if (!response) {
			alert(trad_recaptcha_error);
			reject();
		}
		resolve();
	});
}
window.setRecaptchaFormValue = setRecaptchaFormValue;
